import userConfigReducer from './userConfigReducer';
import searchStateReducer from './searchStateReducer';
import personaReducer from './personaReducer';
import folderReducer from './folderReducer';
import hubReducer from './hubReducer';
import groupsHubReducer from './groupsHubReducer';
import { combineReducers, Reducer, ReducersMapObject } from 'redux';
import type { AppDataState } from '../../state';

const reducer: Reducer<AppDataState> = combineReducers<AppDataState>({
    userConfiguration: userConfigReducer,
    searchState: searchStateReducer,
    personas: personaReducer,
    contactFoldersState: folderReducer,
    hubState: hubReducer,
    groupsHubState: groupsHubReducer,
} as ReducersMapObject<AppDataState>);

export default reducer;
